import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../../contex/AuthProvider';
import toast from 'react-hot-toast';
import { useQuery } from '@tanstack/react-query';
import Loading from '../../../Home/Share/Loading/Loading';

const AllSeller = () => {
    // const [orders, setOrders] = useState(null);
    const { user, loOut } = useContext(AuthContext);
    const { data: orders = [], isLoading, refetch } = useQuery({
        queryKey: ['orders'],
        queryFn: async () => {
            const res = await fetch(`https://assignment-12-server-beige.vercel.app/usersType/u/seller`, {
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            });
            const data = await res.json();
            return data;
        }
    });
    if (isLoading) {
        return <Loading></Loading>
    }

    const handleVerify = (email) => {
        const proceed = window.confirm('Are you sure, you want to verify this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/user/verify/${email}`, {
                method: 'PATCH',
                headers: {
                    'content-type': 'application/json',
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify({ isVerify: true }),
            })
                .then(res =>
                    res.json()
                )
                .then(data => {
                    console.log(data);
                    refetch();
                    toast.success('Successfully verified');
                })
        }
    }

    const handleDelete = (id) => {
        const proceed = window.confirm('Are you sure, you want to cancel this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/users/${id}`, {
                method: 'DELETE',
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            })
                .then(res => {
                    res.json()
                })
                .then(data => {
                    refetch()
                    toast.success('Successfully delete');
                    console.log(data);
                })
        }
    }
    return (
        <div>

            <h3 className='text-3xl font-semibold mb-5 text-center'>All seller</h3>


            <div className="overflow-x-auto m-3">
                <table className="table w-full">

                    <thead>
                        <tr>
                            <th></th>

                            <th>Name</th>
                            <th>Email</th>
                            <th>Verify</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            orders?.map((book, i) => <tr key={book._id}>
                                <th>{i + 1}</th>
                                <td>{book.name}</td>
                                <td>{book.email}</td>
                                <td>
                                    {
                                        book.isVerify ? <p>verified</p> : <label>
                                            <button onClick={() => handleVerify(book.email)} className='btn btn-primary btn-sm'>verify</button>
                                        </label>
                                    }
                                </td>


                                <td>
                                    <label>
                                        <button onClick={() => handleDelete(book._id)} className='btn btn-primary btn-sm'>Delete</button>
                                    </label>
                                </td>


                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AllSeller;